import React from 'react';
import { translate } from 'react-i18next';

import styles from './HeroSection.scss';
import { func, object } from 'prop-types';

function HeroSection({ t, children }) {
  return (
    <section className={styles.root}>
      <div className={styles.inner}>
        <h1
          className={styles.heading}
          dangerouslySetInnerHTML={{
            __html: `${t('premium.hero.title')}`,
          }}
        />
        <div className={styles.content}>{children}</div>
      </div>
    </section>
  );
}

HeroSection.propTypes = {
  children: object.isRequired,
  t: func.isRequired,
};

export default translate(['premium'])(HeroSection);



// WEBPACK FOOTER //
// ./app/containers/Premium/components/HeroSection/HeroSection.jsx